import { AxiosInstance, AxiosResponse } from "axios";
import { BoundarySummary } from "../types/Boundary/BoundarySummary";
import { Boundary } from "../types/Boundary/Boundary";
import { UploadBoundaryRequest } from "../types/Boundary/UploadBoundaryRequest";
import { DownloadBoundariesRequest } from "../types/Boundary/DownloadBoundariesRequest";
import { DownloadBoundaryResponse } from "../types/Boundary/DownloadBoundaryResponse";

export default class BoundaryService {
  private _endpoint = "Boundary";
  private _lbBaseUrl = process.env.REACT_APP_LB_URL;
  private _client: AxiosInstance;

  constructor(client: AxiosInstance) {
    this._client = client;
  }

  public listAll(): Promise<BoundarySummary[]> {
    return this._client.get<any>(`${this._endpoint}/all`).then((response) => {
      return response.data;
    });
  }

  public searchBoundary(searchTerm: string): Promise<BoundarySummary[]> {
    return this._client
      .get<any>(`${this._endpoint}?searchTerm=${searchTerm}`)
      .then((response) => {
        return response.data;
      });
  }

  public getById(id: number | string): Promise<Boundary> {
    return this._client
      .get<any>(`${this._endpoint}/${id}?projection=3857`)
      .then((response) => {
        return response.data;
      });
  }

  public UploadBoundary(request: UploadBoundaryRequest): Promise<Boundary> {
    if(request.file === undefined) {
      return Promise.reject(new Error("File is required"));
    }

    const fileName = request.file.name;
    const fileExtension = fileName.substring(fileName.lastIndexOf('.') + 1).toLowerCase();
    
    let url = `${this._endpoint}/shapefile?projection=3857`;
    if (fileExtension === "json" || fileExtension === "geojson") {
      url = `${this._endpoint}/geojson?projection=3857`;
    } else if (fileExtension === "shp") {
      url = `${this._endpoint}/shapefile?projection=3857`;
    }
    
    return this._client
      .post<any>(url, request, {
        baseURL: this._lbBaseUrl,
        headers: {
          "Content-Type": "multipart/form-data",
        },
      })
      .then((response) => {
        return response.data;
      });
  }

  public DeleteCustomBoundary(id: number | string): Promise<void> {
    return this._client.delete(`${this._endpoint}/${id}`);
  }

  public DownloadBoundaries(
    request: DownloadBoundariesRequest,
  ): Promise<DownloadBoundaryResponse> {
    return this._client
      .post(`${this._endpoint}/download`, request, {
        responseType: "blob",
      })
      .then((response: AxiosResponse<Blob>) => {
        const fileName = this.GetFilename(response);
        return {
          data: new Blob([response.data]),
          fileName: fileName,
        };
      });
  }

  private GetFilename(response: AxiosResponse) {
    const contentDisposition = response.headers["content-disposition"];
    if (contentDisposition !== null) {
      const pattern = new RegExp("filename=([^;$]*)");
      const match = pattern.exec(response.headers["content-disposition"]);
      if (match && match.length >= 2) return match[1];
    }

    throw new Error("Could not get filename");
  }
}
